import { Component, OnInit, Input, ViewChild, ElementRef, ChangeDetectorRef, AfterContentInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ModalController, ToastController } from '@ionic/angular';
import { UserService } from 'src/app/services/user.service';
import { KilnService } from 'src/app/services/kiln.service';
import { AccountService } from 'src/app/services/account.service';
import { AdminLoginAsService } from 'src/app/services/admin-login-as.service';
import { Router } from '@angular/router';


@Component({
  selector: 'app-login-as-popup',
  templateUrl: './login-as-popup.component.html',
  styleUrls: ['./login-as-popup.component.scss'],
})
export class LoginAsPopupComponent implements OnInit {
  public onDismiss;

  public users = [];
  public users_by_company = [];
  public retrieving;
  public searching = false;
  public hasSearched = false;
  public filteredUsers;
  public filteredUsersByCompany;

  public searchForm: UntypedFormGroup;
  @ViewChild('searchTermId') searchTermId: ElementRef;

  constructor(private userService: UserService,
    private kilnService: KilnService,
    private accountService: AccountService,
    private adminLoginAsService: AdminLoginAsService,
    private toastCtrl: ToastController,
    private ref: ChangeDetectorRef,
    private router: Router) {}

  ngOnInit() {}

  runSearch() {
    const term = this.searchForm && this.searchForm.value && this.searchForm.value.searchTerm;
    const trimmed = term && String(term).trim();
    if (!trimmed) {
      this.showMessage('Please enter a search term to find users.');
      return;
    }
    this.getUsers(trimmed);
  }

  getUsers(searchTerm?: string) {
    const term = searchTerm != null ? String(searchTerm).trim() : (this.searchForm && this.searchForm.value && this.searchForm.value.searchTerm && String(this.searchForm.value.searchTerm).trim());
    if (!term || this.retrieving) return;
    this.retrieving = true;
    this.hasSearched = true;
    this.users = [];
    this.users_by_company = [];
    this.filteredUsers = undefined;
    this.filteredUsersByCompany = undefined;
    this.userService.getUsersAsAdmin(term)
          .then((data) => {
            this.users_by_company = data || [];
            this.users_by_company.forEach((company) => {
              this.users = this.users.concat(company.users || []);
            });
            this.retrieving = false;
            this.ref.detectChanges();
          })
          .catch((error) => {
            this.retrieving = false;
            this.hasSearched = false;
            this.showMessage('There was an error getting the list of users, please try again.');
          });
  }

  loginAs(user, account_id) {
    void this.adminLoginAsService.executeLoginAs(user, account_id, { navigateToKilnList: false }).then((data) => {
      if (data) {
        this.dismiss(data);
      } else {
        this.dismiss();
      }
    });
  }

  exitLoginAs() {
    this.userService.unsetLoginAs();
    this.accountService.unsetLoginAs();
    this.dismiss();
  }

  startSearch() {
    this.searching = true;
    this.searchForm = new UntypedFormGroup({
      searchTerm: new UntypedFormControl('')
    });
    this.ref.detectChanges();
    if(this.searchTermId) { this.searchTermId.nativeElement.focus(); }
  }

  filter(value) {
    if (!value || !value.searchTerm) {
      this.runSearch();
      return;
    }
    const term = String(value.searchTerm).toLowerCase();
    const filterRegex = new RegExp(term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
    this.filteredUsers = this.users.filter((a) => {
      return a && (
        filterRegex.test((a.username && a.username.toLowerCase()) || '') ||
        filterRegex.test((a.email && a.email.toLowerCase()) || '') ||
        filterRegex.test((a.first_name && a.first_name.toLowerCase()) || '') ||
        filterRegex.test((a.last_name && a.last_name.toLowerCase()) || '')
      );
    });

    this.filteredUsersByCompany = this.users_by_company.reduce((aggregate, c) => {
      const company_copy = { ...c, users: c.users ? [...c.users] : [] };
      const company_name_match = company_copy.name && filterRegex.test(company_copy.name.toLowerCase());
      if (!company_name_match && company_copy.users) {
        company_copy.users = company_copy.users.filter((a) =>
          a && (
            filterRegex.test((a.username && a.username.toLowerCase()) || '') ||
            filterRegex.test((a.email && a.email.toLowerCase()) || '') ||
            filterRegex.test((a.first_name && a.first_name.toLowerCase()) || '') ||
            filterRegex.test((a.last_name && a.last_name.toLowerCase()) || '')
          )
        );
      }
      if (company_name_match || (company_copy.users && company_copy.users.length > 0)) {
        aggregate.push(company_copy);
      }
      return aggregate;
    }, []);
  }

  cancelSearch() {
    this.searching = false;
    this.filteredUsers = undefined;
  }

  getUsersToShow() {
    return this.filteredUsersByCompany ? this.filteredUsersByCompany : this.users_by_company;
  }

  async showMessage(msg) {
    let toast = await this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'middle'
    });

    toast.present();
  }

  showUserNotAssociatedToAccountMessage() {
    this.showMessage("User is not associated to an account yet");
  }

  dismiss(data = null) {
    this.onDismiss ? this.onDismiss(data) : this.router.navigate(['landing']);
  }
}
